import { ConfigContext } from 'context/config';
import React, { useContext } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

const MetaTags = ({ group, location }) => {
  const [t] = useTranslation('dcc');
  const { REACT_APP_UI_URL } = useContext(ConfigContext);

  const title = t('header', {
    defaultValue: 'Connect With {{ church_name }}!',
    church_name: group.account_name,
  });
  const description = t('prompt');
  return (
    <Helmet title={title}>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={REACT_APP_UI_URL + location.pathname} />
      <meta property="og:image" content={group.account_logo_url} />
      <meta name="twitter:card" content={group.account_logo_url} />
      <meta name="twitter:site" content="@textinchurch" />
      <meta name="twitter:creator" content="@textinchurch" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={group.account_logo_url} />
    </Helmet>
  );
};

export default MetaTags;
